/**
 * In-memory bridge for inversion models between the 2D map page and the
 * 3D viewer page (client-side routing keeps module state alive).
 * Models can be large — keeping them out of React context avoids re-renders.
 */
let _models = [];

export function setStoredInversionModels(models) {
  _models = models || [];
}

export function getStoredInversionModels() {
  return _models;
}

/**
 * How the 3D viewer shows an inversion model entry (components/SubsurfaceViewer3D.js):
 * 'fence' (2D model with a two-point georeferenced line), 'volume' (georeferenced 3D
 * grid / mesh3d), or null (local coordinates, 1D sounding: listed but not drawn).
 */
export function model3dKind(entry) {
  if (!entry?.cells?.length) return null;
  if (entry.line?.length === 2) return 'fence';
  if (['grid', 'mesh3d'].includes(entry.model?.geometryKind) && entry.cells[0]?.lon !== undefined) return 'volume';
  return null;
}

/** The map session's models plus the project's stored ones, without the stored copies
 *  of models the session already has (same backendId). */
export function mergeInversionModels(sessionModels = [], storedModels = []) {
  const have = new Set(sessionModels.map(m => m.backendId).filter(Boolean));
  return [...sessionModels, ...storedModels.filter(m => !have.has(m.backendId))];
}
